export default __webpack_public_path__ + "static/media/03AW1SEP66.c5b81f53.jpg";